/**
 * Created by henian.xu on 2017/10/24.
 * api 入口
 */

export { default as Buyer } from './buyer/index'; // 买家模块
export { default as Comm } from './comm/index'; // 公共模块
export { default as Feedback } from './feedback/index'; // 公共模块
